import styles from './styles.module.scss';
import ActionBar from '../action-bar';
import MenuButton from '../menu';
import Breadcrumb from '../breadcrumb';
import Profile from '../profile';
import { useMenu } from 'context/MenuContext';
import CustomConfig from 'models/CustomConfig';

function Navbar(props : CustomConfig) : JSX.Element {
  const {
    setCustomConfig
  } = useMenu();

  setCustomConfig(props);

  return (
    <nav id={styles['biobar-container']}>
      <MenuButton />
      <Breadcrumb />
      <ActionBar />
      <Profile />
    </nav>
  );
}

export default Navbar;
